import { Add } from 'iconsax-react';
import type { ReactNode } from 'react';
import CheckIcon from '@/assets/images/icons/check.svg?react';
import type { Tag } from '@/models/user/tag';
import cn from '@/utils/merge-class-names';

export enum PrefixType {
  check = 'check',
  remove = 'remove',
  add = 'add',
  none = 'none',
}

type TagProps = {
  tag: Tag;
  className?: string;
  prefix?: PrefixType;
  variant?: 'outlined' | 'primary' | 'secondary' | 'inverse-secondary';
  onClick?: (tag: Tag) => void;
};

const prefixMap: Record<PrefixType, ReactNode> = {
  check: <CheckIcon className='size-4 ' />,
  remove: <Add className='size-4 rotate-45' />,
  add: <Add className='size-4 ' />,
  none: null,
};

export default function TagItem({ tag, className, variant = 'outlined', prefix = PrefixType.none, onClick }: TagProps) {
  const content = (
    <div
      className={cn(
        'btn btn-sm text-body1 rounded-lg font-normal py-1 px-2.5 gap-0.5',
        {
          'btn-primary text-white': variant === 'primary',
          'bg-metal-100 text-metal-600': variant === 'secondary',
          'bg-metal-300 text-white border-metal-300': variant === 'inverse-secondary',
          'btn-outline text-secondary': variant === 'outlined',
        },
        className,
      )}>
      {prefixMap[prefix]}

      {tag.TagName}
    </div>
  );

  if (onClick) {
    return (
      <button
        type='button'
        onClick={() => onClick(tag)}>
        {content}
      </button>
    );
  }

  return content;
}
